import React from 'react';
import { Typography, Box, Chip, Table, TableBody, TableRow } from '@mui/material';
import { TaskDetailsBox, TaskDetailsCell } from './styles/plannedVsActualReportStyles';
import { StatusChip } from './StatusChip';

export const TaskDetails = ({ task }) => (
  <TaskDetailsBox>
    <Table size="small">
      <TableBody>
        <TableRow>
          {task.user && (
            <TaskDetailsCell sx={{ width: '20%' }}>
              <Typography variant="caption" color="text.secondary">
                Assign To
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                {task?.userName}
              </Typography>
            </TaskDetailsCell>
          )}
          <TaskDetailsCell sx={{ width: '20%', borderBottom: 'none' }}>
            <Typography variant="caption" color="text.secondary">
              Type
            </Typography>
            <Box sx={{ mt: 1 }}>
              <StatusChip status={task.taskType} type="type" />
            </Box>
          </TaskDetailsCell>
          <TaskDetailsCell sx={{ width: '20%', borderBottom: 'none' }}>
            <Typography variant="caption" color="text.secondary">
              Progress
            </Typography>
            <Box sx={{ mt: 1 }}>
              <StatusChip
                status={Math.round((task.consumedSeconds / task.plannedSeconds) * 100) || 0}
                type="progress"
              />
            </Box>
          </TaskDetailsCell>
          <TaskDetailsCell sx={{ borderBottom: 'none' }}>
            {task.description && (
              <>
                <Typography variant="caption" color="text.secondary">
                  Description
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }} dangerouslySetInnerHTML={{ __html: task.description }} />
              </>
            )}
          </TaskDetailsCell>
        </TableRow>
      </TableBody>
    </Table>
  </TaskDetailsBox>
);
